module.exports = __webpack_public_path__ + "img/header-engagementRingsHeart.def8ea6.webp";